import { useCampaigns } from '@/hooks/useCampaigns';
import { useTeams } from '@/hooks/useTeams';
import { useMemo } from 'react';

export const useTeamStatus = () => {
  const { activeTeam } = useTeams();
  const { data: campaigns, isLoading: isCampaignsLoading } = useCampaigns();
  const isTeamLoading = activeTeam.isLoading;
  const isInitalising = isCampaignsLoading || activeTeam.isLoading;

  const teamSocialsConnected = useMemo(() => {
    if (!activeTeam.data || isTeamLoading) return false;

    return !!activeTeam.data.tokens;
  }, [activeTeam.data, isTeamLoading]);

  const teamOnboardingComplete = useMemo(() => {
    if (!activeTeam.data || isTeamLoading) return false;

    return (
      activeTeam.data.audience !== null &&
      activeTeam.data.description !== null &&
      activeTeam.data.industry !== null &&
      activeTeam.data.tone_and_style !== null &&
      activeTeam.data.posting_frequency !== null &&
      activeTeam.data.brand_voice !== null
    );
  }, [activeTeam.data, isTeamLoading]);

  const hasSetupFirstCampaign = useMemo(() => {
    if (!campaigns || isCampaignsLoading) return false;

    return campaigns.length > 0;
  }, [campaigns, isCampaignsLoading]);

  const hasFacebookAccount = useMemo(() => {
    if (!activeTeam.data || isTeamLoading) return false;

    return !!activeTeam.data.facebook_account;
  }, [activeTeam.data, isTeamLoading]);

  return {
    teamSocialsConnected,
    teamOnboardingComplete,
    hasSetupFirstCampaign,
    hasFacebookAccount,
    isInitalising,
  };
};
